import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function MagneticButton({
  to,
  href,
  children,
  variant = "primary",
  className = "",
  onClick,
}) {
  const ref = useRef(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = (e.clientX - rect.left - rect.width / 2) * 0.15;
    const y = (e.clientY - rect.top - rect.height / 2) * 0.15;
    setOffset({ x, y });
  };

  const handleLeave = () => setOffset({ x: 0, y: 0 });

  const variants = {
    primary: "hero-btn-primary text-white",
    gold: "hero-btn-gold font-bold",
    glass: "hero-btn-glass text-white",
  };

  const baseClass = `inline-flex items-center justify-center gap-2.5 px-7 py-3.5 rounded-xl text-sm font-semibold tracking-wide ${variants[variant]} ${className}`;

  const style = { transform: `translate(${offset.x}px, ${offset.y}px)` };

  const inner = (
    <motion.span
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      style={style}
      whileTap={{ scale: 0.97 }}
      className={baseClass}
    >
      {children}
    </motion.span>
  );

  if (href) {
    return (
      <a href={href} className="inline-block" onClick={onClick}>
        {inner}
      </a>
    );
  }

  return (
    <Link to={to} className="inline-block">
      {inner}
    </Link>
  );
}
